import * as Yup from 'yup'
import i18n from 'core/common/i18n'

export const SimpleProductFreightSchema = Yup.object().shape({
  package: Yup.object()
    .shape({
      weight: Yup.object()
        .shape({
          value: Yup.number()
            .typeError(i18n.t('product.validations.onlyNumbers'))
            .moreThan(0, i18n.t('product.validations.minValue'))
            .when('$weightUn', {
              is: weightUn => weightUn === 'kg',
              then: schema =>
                schema.max(
                  1510,
                  i18n.t('product.validations.maxWeight', { count: 1510, unit: 'kg' })
                ),
              otherwise: schema =>
                schema.max(
                  1510000,
                  i18n.t('product.validations.maxWeight', { count: 1510000, unit: 'g' })
                ),
            })
            .required(i18n.t('product.validations.required')),
        })
        .required(i18n.t('product.validations.required')),
      depth: Yup.number()
        .typeError(i18n.t('product.validations.onlyNumbers'))
        .moreThan(0, i18n.t('product.validations.minValue'))
        .when('$dimensionUn', {
          is: dimensionUn => dimensionUn === 'm',
          then: schema =>
            schema.max(10000, i18n.t('product.validations.maxWeight', { count: 10000, unit: 'm' })),
          otherwise: schema =>
            schema.max(
              1000000,
              i18n.t('product.validations.maxWeight', { count: 1000000, unit: 'cm' })
            ),
        })
        .required(i18n.t('product.validations.required')),
      height: Yup.number()
        .typeError(i18n.t('product.validations.onlyNumbers'))
        .moreThan(0, i18n.t('product.validations.minValue'))
        .when('$dimensionUn', {
          is: dimensionUn => dimensionUn === 'm',
          then: schema =>
            schema.max(10000, i18n.t('product.validations.maxWeight', { count: 10000, unit: 'm' })),
          otherwise: schema =>
            schema.max(
              1000000,
              i18n.t('product.validations.maxWeight', { count: 1000000, unit: 'cm' })
            ),
        })
        .required(i18n.t('product.validations.required')),
      width: Yup.number()
        .typeError(i18n.t('product.validations.onlyNumbers'))
        .moreThan(0, i18n.t('product.validations.minValue'))
        .when('$dimensionUn', {
          is: dimensionUn => dimensionUn === 'm',
          then: schema =>
            schema.max(10000, i18n.t('product.validations.maxWeight', { count: 10000, unit: 'm' })),
          otherwise: schema =>
            schema.max(
              1000000,
              i18n.t('product.validations.maxWeight', { count: 1000000, unit: 'cm' })
            ),
        })
        .required(i18n.t('product.validations.required')),
      weightUn: Yup.string().required(i18n.t('product.validations.required')),
    })
    .required(i18n.t('product.validations.required')),
})

export const VariationProductFreightSchema = Yup.object().shape({
  variations: Yup.array()
    .of(
      Yup.object()
        .shape({
          package: Yup.object()
            .shape({
              weight: Yup.object()
                .shape({
                  value: Yup.number()
                    .typeError(i18n.t('product.validations.onlyNumbers'))
                    .moreThan(0, i18n.t('product.validations.minValue'))
                    .when('$weightUn', {
                      is: weightUn => weightUn === 'kg',
                      then: schema =>
                        schema.max(
                          1510,
                          i18n.t('product.validations.maxWeight', { count: 1510, unit: 'kg' })
                        ),
                      otherwise: schema =>
                        schema.max(
                          1510000,
                          i18n.t('product.validations.maxWeight', { count: 1510000, unit: 'g' })
                        ),
                    })
                    .required(i18n.t('product.validations.required')),
                })
                .required(i18n.t('product.validations.required')),
              depth: Yup.number()
                .typeError(i18n.t('product.validations.onlyNumbers'))
                .moreThan(0, i18n.t('product.validations.minValue'))
                .when('$dimensionUn', {
                  is: dimensionUn => dimensionUn === 'm',
                  then: schema =>
                    schema.max(
                      10000,
                      i18n.t('product.validations.maxWeight', { count: 10000, unit: 'm' })
                    ),
                  otherwise: schema =>
                    schema.max(
                      1000000,
                      i18n.t('product.validations.maxWeight', { count: 1000000, unit: 'cm' })
                    ),
                })
                .required(i18n.t('product.validations.required')),
              height: Yup.number()
                .typeError(i18n.t('product.validations.onlyNumbers'))
                .moreThan(0, i18n.t('product.validations.minValue'))
                .when('$dimensionUn', {
                  is: dimensionUn => dimensionUn === 'm',
                  then: schema =>
                    schema.max(
                      10000,
                      i18n.t('product.validations.maxWeight', { count: 10000, unit: 'm' })
                    ),
                  otherwise: schema =>
                    schema.max(
                      1000000,
                      i18n.t('product.validations.maxWeight', { count: 1000000, unit: 'cm' })
                    ),
                })
                .required(i18n.t('product.validations.required')),
              width: Yup.number()
                .typeError(i18n.t('product.validations.onlyNumbers'))
                .moreThan(0, i18n.t('product.validations.minValue'))
                .when('$dimensionUn', {
                  is: dimensionUn => dimensionUn === 'm',
                  then: schema =>
                    schema.max(
                      10000,
                      i18n.t('product.validations.maxWeight', { count: 10000, unit: 'm' })
                    ),
                  otherwise: schema =>
                    schema.max(
                      1000000,
                      i18n.t('product.validations.maxWeight', { count: 1000000, unit: 'cm' })
                    ),
                })
                .required(i18n.t('product.validations.required')),
            })
            .required(i18n.t('product.validations.required')),
        })
        .required(i18n.t('product.validations.required'))
    )
    .min(1, i18n.t('product.validations.required'))
    .required(i18n.t('product.validations.required')),
})
